export default __webpack_public_path__ + "static/media/ordered.c46e4db8.svg";